import React from 'react';

function TruckIcon({ className = '' }) {
	let fillColor = className.includes('active') ? '#212121' : '#9E9E9E';

	return (
		<svg
			width='24'
			height='17'
			viewBox='0 0 24 17'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path d='M0 0V10.598H14.088V0H0Z' fill={fillColor} />
			<path
				d='M20.544 14.3173H16.84C16.977 13.9371 17.2285 13.6085 17.5599 13.3761C17.8914 13.1438 18.2867 13.0191 18.692 13.0191C19.0972 13.0191 19.4925 13.1438 19.824 13.3761C20.1555 13.6085 20.4069 13.9371 20.544 14.3173Z'
				fill={fillColor}
			/>
			<path
				d='M19.68 2.40826H15.2672V14.3172H16.0672C16.2159 13.7359 16.5547 13.2204 17.03 12.8523C17.5053 12.4841 18.0901 12.2843 18.692 12.2843C19.2939 12.2843 19.8787 12.4841 20.354 12.8523C20.8293 13.2204 21.1681 13.7359 21.3168 14.3172H23.1008V8.18971L19.68 2.40826ZM16.3664 7.05575V3.63473H18.9856L21.016 7.06691L16.3664 7.05575Z'
				fill={fillColor}
			/>
			<path
				d='M6.68801 14.3173H2.98401C3.12107 13.9371 3.37251 13.6085 3.70398 13.3761C4.03545 13.1438 4.43079 13.0191 4.83601 13.0191C5.24123 13.0191 5.63657 13.1438 5.96804 13.3761C6.29951 13.6085 6.55094 13.9371 6.68801 14.3173Z'
				fill={fillColor}
			/>
			<path
				d='M20.544 14.3173H16.84C16.977 13.9371 17.2285 13.6085 17.5599 13.3761C17.8914 13.1438 18.2867 13.0191 18.692 13.0191C19.0972 13.0191 19.4925 13.1438 19.824 13.3761C20.1555 13.6085 20.4069 13.9371 20.544 14.3173Z'
				fill={fillColor}
			/>
			<path
				d='M24 11.7192V14.3173H21.3168C21.1681 13.7359 20.8293 13.2205 20.354 12.8523C19.8787 12.4842 19.2939 12.2844 18.692 12.2844C18.0901 12.2844 17.5053 12.4842 17.03 12.8523C16.5547 13.2205 16.2159 13.7359 16.0672 14.3173H7.4608C7.31207 13.7359 6.9733 13.2205 6.498 12.8523C6.02269 12.4842 5.43792 12.2844 4.836 12.2844C4.23408 12.2844 3.64931 12.4842 3.174 12.8523C2.6987 13.2205 2.35993 13.7359 2.2112 14.3173H0V11.7192H24Z'
				fill={fillColor}
			/>
			<path
				d='M6.80473 14.9807C6.81224 15.2432 6.76687 15.5044 6.6713 15.7491C6.57574 15.9937 6.43192 16.2168 6.24836 16.405C6.06479 16.5933 5.84522 16.7429 5.60261 16.8451C5.36001 16.9473 5.09931 17 4.83593 17C4.57256 17 4.31186 16.9473 4.06925 16.8451C3.82665 16.7429 3.60707 16.5933 3.42351 16.405C3.23995 16.2168 3.09613 15.9937 3.00056 15.7491C2.905 15.5044 2.85963 15.2432 2.86713 14.9807C2.86641 14.7544 2.90595 14.5298 2.98393 14.3173C3.121 13.9371 3.37243 13.6085 3.7039 13.3761C4.03537 13.1438 4.43071 13.0191 4.83593 13.0191C5.24115 13.0191 5.63649 13.1438 5.96796 13.3761C6.29943 13.6085 6.55087 13.9371 6.68793 14.3173C6.76591 14.5298 6.80546 14.7544 6.80473 14.9807Z'
				fill={fillColor}
			/>
			<path
				d='M20.6608 14.9807C20.6683 15.2432 20.6229 15.5044 20.5274 15.7491C20.4318 15.9937 20.288 16.2168 20.1044 16.405C19.9209 16.5933 19.7013 16.7429 19.4587 16.8451C19.2161 16.9473 18.9554 17 18.692 17C18.4286 17 18.1679 16.9473 17.9253 16.8451C17.6827 16.7429 17.4632 16.5933 17.2796 16.405C17.096 16.2168 16.9522 15.9937 16.8566 15.7491C16.7611 15.5044 16.7157 15.2432 16.7232 14.9807C16.7225 14.7544 16.762 14.5298 16.84 14.3173C16.9771 13.9371 17.2285 13.6085 17.56 13.3761C17.8915 13.1438 18.2868 13.0191 18.692 13.0191C19.0972 13.0191 19.4926 13.1438 19.824 13.3761C20.1555 13.6085 20.4069 13.9371 20.544 14.3173C20.622 14.5298 20.6615 14.7544 20.6608 14.9807Z'
				fill={fillColor}
			/>
		</svg>
	);
}

export default TruckIcon;
